export const aboutUsEs = {
  about: {
    aboutMenuHeader:"Nosotros",
    titleLinkMenu: "Sobre nosotros",
    title: "Sobre nosotros",
    subTitle: "¿Qué nos mueve?",
    description1:
      `Pasar del plan a los resultados.
      
      - Convertir decisiones en soluciones que funcionan, que se adoptan, que generan impacto real, con tecnología.
      - Diseñamos, operamos y escalamos ecosistemas digitales combinando ingeniería con visión de negocio.
      - Acompañamos a los equipos hasta que la tecnología se convierta en parte de su día a día.

      Porque ahí es donde sucede el verdadero cambio: en las personas, en los procesos y en el negocio.`,
    whatWeAre: "Quienes somos",
  },
  bannerAboutUs: {
    title: "Qué nos mueve",
    description1: "Creemos que la digitalización ayuda a la evolución del mundo, e integra a personas y empresas, facilitando su desarrollo.",
    description2: "En todo lo que hacemos, apostamos por la innovación y lo hacemos mediante una cuidadosa integración de recursos humanos y tecnología.",
  },
  valueProposalAboutUs: {
    toptitle: "Sobre nosotros",
    title: "Propuesta de valor",
    description1: "Proporcionamos servicios que abordan este vacío crítico, permitiendo que las empresas que no son expertas en tecnología naveguen con confianza la complejidad del panorama tecnológico y digital, innoven sin restricciones y se mantengan competitivas, asegurando así su relevancia y prosperidad en un mercado que no perdona a los que no se adaptan.",
  },
  ourWorkAboutUs: {
    title: "Nuestro Trabajo",
    description1: "Desarrollamos productos y servicios digitales, enfocados en la mejor experiencia de los usuarios.",
  },
};

export const aboutUsEn = {
  about: {
    aboutMenuHeader:"{{aboutMenuHeader}}",
    titleLinkMenu:"{{titleLinkMenu}}",
    title: "{{title}}",
    subTitle: "{{subTitle}}",
    description1: "{{description1}}",
    description2: "{{description2}}",
    whatWeAre: "{{whatWeAre}}",
  },
  bannerAboutUs: {
    title: "{{title}}",
    description1: "{{description1}}",
    description2: "{{description2}}",
  },
  valueProposalAboutUs: {
    toptitle: "{{toptitle}}",
    title: "{{title}}",
    description1: "{{description1}}",
    description2: "{{description2}}",
  },
  ourWorkAboutUs: {
    title: "{{title}}",
    description1: "{{description1}}",
  },
};
